import { FC, memo, ReactNode } from 'react';

import './Page.css';

interface PageProps {
    className?: string;
    children?: ReactNode;
}

/** Виджет страницы */
export const Page: FC<PageProps> = memo((props: PageProps) => {
    const { className = '', children } = props;

    return <div className={`Page ${className}`}>{children}</div>;
});
